<script setup lang="ts">
import VInlineButton from "@magnit/core/src/components/VInlineButton/VInlineButton.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import VHeartIcon from "@magnit/icons/src/assets/svg/icons/base/24-outline-heart.svg";
import VHeartIconFilled from "@magnit/icons/src/assets/svg/icons/base/24-system-heart.svg";
import type {
  IFavoriteButtonProps,
  IFavoriteButtonEmits,
} from "./VFavoriteButton.types";

defineProps<IFavoriteButtonProps>();

const emit = defineEmits<IFavoriteButtonEmits>();

const handleClick = () => emit("click");
</script>

<template>
  <VInlineButton
    theme="secondary"
    :loading="loading"
    class="favorite-button"
    @click.stop.prevent="handleClick"
  >
    <template #icon>
      <VIcon>
        <VHeartIconFilled
          v-if="favorite"
          class="favorite-button__icon-filled"
        />
        <VHeartIcon v-else class="favorite-button__icon" />
      </VIcon>
    </template>
  </VInlineButton>
</template>
